import * as React from 'react';
import { Accordion, Content } from '../common';
import { Grid, Container } from '../helpers/Grid';
import FaqsProps from './type';
import './styles.scss';

const Faqs = ({
  title,
  intro,
  themeColor,
  faqs,
  sanctions,
  suspensions,
}: FaqsProps) => (
  <section className={`faqs faqs--${themeColor}`}>
    <Container>
      <Grid className="faqs__container">
        {title && (
          <Grid.Column sm={6} md={8} lg={8} xl={10}>
            <Content
              title={title}
              intro={intro}
              containerTheme={themeColor}
              isTitleFloating
            />
          </Grid.Column>
        )}

        {faqs && faqs.length > 0 && (
          <Grid.Column className="faqs__accordion" sm={6} md={8} lg={8} xl={10}>
            <Accordion panels={faqs} themeColor={themeColor} />
          </Grid.Column>
        )}
        {sanctions && sanctions.length > 0 && (
          <Grid.Column className="faqs__accordion" sm={6} md={8} lg={8} xl={10}>
            <Accordion
              panels={sanctions}
              themeColor={themeColor}
              isSanctionSuspension
            />
          </Grid.Column>
        )}
        {suspensions && suspensions.length > 0 && (
          <Grid.Column className="faqs__accordion" sm={6} md={8} lg={8} xl={10}>
            <Accordion
              panels={suspensions}
              themeColor={themeColor}
              useSuspensionTitle
              isSanctionSuspension
            />
          </Grid.Column>
        )}
      </Grid>
    </Container>
  </section>
);

export default Faqs;
